import React, { useState } from "react";
import { CategorySection } from "../categories/CategorySection";
import { CategoryEntityType } from "@/types/category";
import { FAQListSection } from "./FAQListSection";
import { useTranslation } from "react-i18next";

export const FAQsPage: React.FC = () => {
  const { t } = useTranslation();
  const [selectedCategoryId, setSelectedCategoryId] = useState<
    string | undefined
  >();

  return (
    <div className="flex h-[calc(100dvh-80px)] flex-col gap-6 overflow-auto p-6 lg:flex-row lg:overflow-hidden">
      <CategorySection
        entityType={CategoryEntityType.FAQ}
        title={t("categories:categoriesTitle")}
        className="w-full shrink-0 lg:w-[320px] xl:w-1/4"
        selectedCategoryId={selectedCategoryId}
        onCategorySelect={setSelectedCategoryId}
      />
      <div className="min-h-[420px] min-w-0 flex-1">
        {selectedCategoryId ? (
          <FAQListSection categoryId={selectedCategoryId} />
        ) : (
          <div className="border-base-border text-muted-foreground flex h-full flex-col items-center justify-center rounded-xl border bg-white shadow-sm">
            {t("Select a category to view FAQs")}
          </div>
        )}
      </div>
    </div>
  );
};
